import React, { useState } from 'react';
import ModalImageDash from '../../../../../components/NovoSistema/ModalImageDash';

export default function TOC() {
  const [openModal, setOpenModal] = useState(false);
  return (
    <div>
      <img
        onClick={() => setOpenModal(true)}
        src="/docs/fianceiroHospitalar/GestaoDeCusto/TOC.png"
        alt="TOC"
        style={{ width: '100%' }}
      />
      {openModal && (
        <ModalImageDash close={setOpenModal} src="/docs/fianceiroHospitalar/GestaoDeCusto/TOC.png" alt="TOC" />
      )}
    </div>
  );
}
